export const DASHBOARD = '/dashboard';

export const VENDOR_DASHBOARD = '/vendor/dashboard';
export const LOGIN = '/';
export const CUSTOMER_LOGIN = '/customer/login';
export const ADD_CUSTOMER = '/customers/add';
export const VIEW_CUSTOMER = '/customers/view/:customerId';
export const EDIT_CUSTOMER = '/customers/edit/:customerId';
export const CUSTOMERS = '/customers';
export const ADD_STAFF = '/staffs/add';
export const VIEW_STAFF = '/staffs/view/:staffId';
export const EDIT_STAFF = '/staffs/edit/:staffId';
export const STAFFS = '/staffs';
export const ADD_VENDOR = '/vendors/add';
export const VIEW_VENDOR = '/vendors/view/:vendorId';
export const EDIT_VENDOR = '/vendors/edit/:id';

export const VENDORS = '/vendors';
export const VENDOR_LOGIN = '/vendor/login';
export const CHANGE_PASSWORD = '/change-password';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password';
export const VERIFY_EMAIL = '/verify-email';
export const ADD_ROLE = '/roles/add';
export const VIEW_ROLE = '/roles/view/:id';
export const EDIT_ROLE = '/roles/edit/:id';

export const ADD_AIRPORT = '/airports/add';
export const VIEW_AIRPORT = '/airports/view';
export const EDIT_AIRPORT = '/airports/edit';
export const AIRPORTS = '/airports';

export const ROLES = '/roles';
export const BOOKING_SUMMARY = '/bookings/summary';
export const ADD_SERVICE_FORM = '/add-service';
export const PROFILE_UPDATE = '/profile';
export const REPORTS = '/reports';
export const BOOKING_AIRPORT_DETAILS = '/bookings/airport-data';
export const BOOKING_PASSENGER_DETAILS = '/bookings/passenger-data';
export const BOOKINGS = '/bookings';
export const VIEW_BOOKINGS = '/bookings/view/:bookingId';
export const EDIT_BOOKINGS = '/bookings/edit/:bookingId';
export const GROUP_BOOKINGS = '/group-bookings';
export const VIEW_GROUP_BOOKINGS = '/group-bookings/view/:bookingId';
export const EDIT_GROUP_BOOKINGS = '/group-bookings/edit/:bookingId';
// export const EDIT_BOOKINGS = "/bookings/edit";
export const SERVICES = '/services';
export const VIEW_SERVICE = '/services/view/:serviceId';
export const EDIT_SERVICE = '/services/edit/:serviceId';
export const ADD_SERVICE = '/services/add';
export const INVOICES = '/invoices';
export const VIEW_INVOICE = '/invoices/view';

export const BILLING_ADDRESS = '/address';

export const ADD_BILLING_ADDRESS = '/address/add';
export const EDIT_BILLING_ADDRESS = '/address/edit/:id';

export const VENDOR_REGISTRATION = '/vendor-registration';
export const CUSTOMER_REGISTRATION = '/customer-registration';
export const VERIFY_OTP = '/verify-otp';
export const STAFF_PROFILE_UPDATE = '/staff-profile';

export const SUCCESS_PAGE = '/bookings/success';
export const COMPLEMENTARY_SUCCESS_PAGE = '/bookings/complementary/success';
export const EDIT_BOOKING_SUCCESS_PAGE = '/bookings/editbookingsuccess';
export const INSTANT_BOOKING_COMPLETED = '/instantbookings/success';
export const INSTANT_BOOKING_SUCCESS_PAGE = '/bookings/instantbookingsuccess';
export const INSTANT_BOOKING_AIRPORT_DETAILS = '/bookings/instantbooking';
export const INSTANT_BOOKING_EXISTING_CUSTOMER =
  '/bookings/instantBooking/seletCustomer';
// export const INSTANT_BOOKING_AIRPORT_DETAILS_BACK = '/instantbooking';
export const INSTANT_BOOKING_PASSENGER_DETAILS =
  '/bookings/instantbooking/passengerDetails';
export const INSTANT_BOOKING_SUMMARY = '/instantbooking/bookingSummary';

export const PAYMENT_SUCCESS = '/payment-success';
export const PAYMENT_FAILURE = '/payment-failure';
export const PAYMENT_PROCESSING = '/payment-process';
export const PAYMENT_CANCLED = '/payment-cancle';
// Without Login Booking
export const UNAUTHORIZE_BOOKING_AIRPORT = '/new-booking/airport-details';
export const UNAUTHORIZE_BOOKING_AIRPORT_DETAILS = '/new-booking';
export const UNAUTHORIZE_BOOKING_PASSENGER_DETAILS =
  '/new-booking/booking-passenger-details';
export const UNAUTHORIZE_BOOKING_SUMMARY = '/new-booking/booking-summary';
export const NOTIFICATIONS = "/notifications";
export const PROMOCODE = "/promo";
export const VIEWPROMO = "/view-promo/:id";
export const EDITPROMO = "/edit-promo/:id";
export const IFRAME_COMPONENT = '/newBooking';
//https://dev.atithiairportseva.com
//https://app.atithiairportseva.com/payment-process
export const DEV_PAYMENT_PROCESSING = 'https://dev.atithiairportseva.com/payment-process';


























